/* =========================================================
   PASEO — Comportements partagés (repris des protos + AJAX cart natif Shopify)
   ========================================================= */
(function () {
  var routes = window.routes || {};
  var money = window.Shopify && window.Shopify.currency ? window.Shopify.currency.active : 'EUR';

  /* ---- hauteur du header -> --hh (cale le contenu sous la bulle) ---- */
  function setHH() {
    var h = document.querySelector('.paseo-header');
    if (h) document.documentElement.style.setProperty('--hh', (h.offsetHeight + 20) + 'px');
  }
  setHH();
  addEventListener('resize', setHH);
  addEventListener('load', setHH);

  /* ---- reveal on scroll ---- */
  var io = new IntersectionObserver(function (es) {
    es.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('in'); io.unobserve(e.target); } });
  }, { threshold: .12 });
  function observeReveals(root) { (root || document).querySelectorAll('.rv:not(.in)').forEach(function (el) { io.observe(el); }); }
  observeReveals();

  /* ---- rails draggables ---- */
  document.querySelectorAll('.rail').forEach(function (r) {
    var dn = false, lx;
    r.addEventListener('pointerdown', function (e) { dn = true; r.classList.add('g'); lx = e.pageX; });
    addEventListener('pointerup', function () { dn = false; r.classList.remove('g'); });
    r.addEventListener('pointermove', function (e) { if (!dn) return; e.preventDefault(); r.scrollLeft -= (e.pageX - lx) * 1.15; lx = e.pageX; });
  });

  /* ---- shop the look : carrousel infini (boucle après le dernier look) ---- */
  (function () {
    var rail = document.querySelector('.stl-rail');
    if (!rail || rail.children.length < 2) return;
    Array.prototype.slice.call(rail.children).forEach(function (n) { rail.appendChild(n.cloneNode(true)); });
    var wrapping = false;
    rail.addEventListener('scroll', function () {
      if (wrapping) return;
      var w = rail.scrollWidth / 2;
      if (rail.scrollLeft >= w) { wrapping = true; rail.scrollLeft -= w; wrapping = false; }
      else if (rail.scrollLeft <= 0) { wrapping = true; rail.scrollLeft += w; wrapping = false; }
    });
    requestAnimationFrame(function () { rail.scrollLeft = 1; });
  })();

  /* ---- méga-menu (survol) ---- */
  document.querySelectorAll('.has-mega').forEach(function (sh) {
    var mg = document.getElementById(sh.dataset.mega || 'mega');
    if (!mg) return;
    var tm;
    var o = function () { clearTimeout(tm); mg.classList.add('on'); };
    var x = function () { tm = setTimeout(function () { mg.classList.remove('on'); }, 130); };
    sh.addEventListener('mouseenter', o); sh.addEventListener('mouseleave', x);
    mg.addEventListener('mouseenter', o); mg.addEventListener('mouseleave', x);
  });

  /* ---- menu mobile (burger + overlay accordéon) ---- */
  var burger = document.getElementById('burger');
  var mnav = document.getElementById('mnav');
  if (burger && mnav) {
    var mnavOpen = function () { mnav.classList.add('on'); burger.setAttribute('aria-expanded', 'true'); mnav.setAttribute('aria-hidden', 'false'); document.documentElement.style.overflow = 'hidden'; };
    var mnavClose = function () { mnav.classList.remove('on'); burger.setAttribute('aria-expanded', 'false'); mnav.setAttribute('aria-hidden', 'true'); document.documentElement.style.overflow = ''; };
    burger.addEventListener('click', function () { mnav.classList.contains('on') ? mnavClose() : mnavOpen(); });
    mnav.querySelectorAll('[data-mnav-close]').forEach(function (b) { b.addEventListener('click', mnavClose); });
    mnav.querySelectorAll('.mnav-body a[href]').forEach(function (a) { a.addEventListener('click', mnavClose); });
    mnav.querySelectorAll('.mnav-h').forEach(function (h) {
      h.addEventListener('click', function () {
        var open = h.getAttribute('aria-expanded') === 'true';
        var sub = h.nextElementSibling;
        h.setAttribute('aria-expanded', open ? 'false' : 'true');
        if (sub) sub.style.maxHeight = open ? '0px' : (sub.scrollHeight + 'px');
      });
    });
    addEventListener('keydown', function (e) { if (e.key === 'Escape' && mnav.classList.contains('on')) mnavClose(); });
    var mnavSearch = document.getElementById('mnavSearch');
    if (mnavSearch) mnavSearch.addEventListener('click', function () { mnavClose(); var sb = document.getElementById('searchBtn'); if (sb) sb.click(); });
  }

  /* ---- éditos : vignette produit gérée 100% en CSS (position:sticky) — aucun JS nécessaire ---- */

  /* ---- overlay recherche + predictive ---- */
  var sov = document.getElementById('sov');
  var sovIn = document.getElementById('sovIn');
  var sovRes = document.getElementById('sovRes');
  var searchBtn = document.getElementById('searchBtn');
  if (searchBtn && sov) {
    searchBtn.addEventListener('click', function () { sov.classList.add('on'); setTimeout(function () { sovIn && sovIn.focus(); }, 80); });
    var sovX = document.getElementById('sovX');
    if (sovX) sovX.addEventListener('click', function () { sov.classList.remove('on'); });
    addEventListener('keydown', function (e) { if (e.key === 'Escape') sov.classList.remove('on'); });
  }
  if (sovIn && sovRes && routes.predictive_search_url) {
    var t;
    sovIn.addEventListener('input', function () {
      clearTimeout(t);
      var q = sovIn.value.trim();
      if (q.length < 2) { sovRes.innerHTML = ''; return; }
      t = setTimeout(function () {
        fetch(routes.predictive_search_url + '?q=' + encodeURIComponent(q) + '&resources[type]=product&resources[limit]=6&section_id=predictive-search')
          .then(function (r) { return r.text(); })
          .then(function () {
            return fetch(routes.predictive_search_url + '.json?q=' + encodeURIComponent(q) + '&resources[type]=product&resources[limit]=6')
              .then(function (r) { return r.json(); });
          })
          .then(function (data) {
            var items = (data.resources && data.resources.results && data.resources.results.products) || [];
            sovRes.innerHTML = items.map(function (p) {
              var img = p.featured_image ? p.featured_image.url : (p.image || '');
              return '<a href="' + p.url + '">' + (img ? '<img src="' + img + '" alt="">' : '') +
                '<span class="r-nm">' + p.title + '</span><span class="r-pr">' + (p.price ? formatMoney(p.price) : '') + '</span></a>';
            }).join('');
          }).catch(function () {});
      }, 220);
    });
  }

  /* ---- cart drawer ---- */
  var scrim = document.getElementById('scrim');
  var drawer = document.getElementById('drawer');
  function openCart() { if (scrim) scrim.classList.add('on'); if (drawer) drawer.classList.add('on'); }
  function closeCart() { if (scrim) scrim.classList.remove('on'); if (drawer) drawer.classList.remove('on'); }
  var cartBtn = document.getElementById('cartBtn');
  if (cartBtn) cartBtn.addEventListener('click', function (e) { e.preventDefault(); openCart(); });
  var cartX = document.getElementById('cartX');
  if (cartX) cartX.addEventListener('click', closeCart);
  if (scrim) scrim.addEventListener('click', closeCart);

  function formatMoney(cents) {
    try { return (cents / 100).toLocaleString('fr-FR', { style: 'currency', currency: money }); }
    catch (e) { return (cents / 100).toFixed(2) + ' €'; }
  }

  function renderCart(cart) {
    var badge = document.querySelector('.bdg');
    if (badge) badge.textContent = cart.item_count;
    var body = document.getElementById('cartBody');
    if (!body) return;
    if (cart.item_count === 0) {
      body.innerHTML = '<div class="e"><p>' + (window.paseoStrings ? window.paseoStrings.empty : 'Votre panier est vide.') +
        '</p><a href="' + ((window.paseoStrings && window.paseoStrings.allProductsUrl) || '/collections/all') + '">' +
        (window.paseoStrings ? window.paseoStrings.explore : 'Découvrir la collection') + '</a></div>';
      return;
    }
    var lines = cart.items.map(function (it, i) {
      var opts = (it.options_with_values || []).map(function (o) { return o.value; }).join(' · ');
      return '<div class="cart-line" data-key="' + it.key + '">' +
        '<a href="' + it.url + '"><img src="' + (it.image ? it.image : '') + '" alt=""></a>' +
        '<div><div class="cl-nm">' + it.product_title + '</div>' +
        (opts ? '<div class="cl-opt">' + opts + '</div>' : '') +
        '<div class="cl-qty"><button data-act="dec" data-line="' + (i + 1) + '" aria-label="-">−</button><span>' + it.quantity + '</span>' +
        '<button data-act="inc" data-line="' + (i + 1) + '" aria-label="+">+</button></div></div>' +
        '<div><div class="cl-pr">' + formatMoney(it.final_line_price) + '</div>' +
        '<button class="cl-rm" data-act="rm" data-line="' + (i + 1) + '">Retirer</button></div></div>';
    }).join('');
    body.innerHTML = '<div class="cart-items">' + lines + '</div>' +
      '<div class="cart-foot"><div class="ct-row"><span>Sous-total</span><span>' + formatMoney(cart.total_price) + '</span></div>' +
      '<div class="ct-note">' + (window.paseoStrings ? window.paseoStrings.shipnote : 'Livraison offerte dès 130 €. Taxes incluses.') + '</div>' +
      '<a class="ct-btn" href="' + (routes.cart_url || '/cart') + '">' + (window.paseoStrings ? window.paseoStrings.checkout : 'Commander') + '</a></div>';
  }

  function fetchCart() {
    return fetch(routes.cart_url + '.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); }).then(renderCart).catch(function () {});
  }
  function changeLine(line, qty) {
    return fetch(routes.cart_change_url + '.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ line: line, quantity: qty })
    }).then(function (r) { return r.json(); }).then(renderCart).catch(function () {});
  }
  var body = document.getElementById('cartBody');
  if (body) {
    body.addEventListener('click', function (e) {
      var b = e.target.closest('[data-act]'); if (!b) return;
      var line = parseInt(b.dataset.line, 10);
      var span = b.parentElement && b.parentElement.querySelector('span');
      var cur = span ? parseInt(span.textContent, 10) : 1;
      if (b.dataset.act === 'inc') changeLine(line, cur + 1);
      else if (b.dataset.act === 'dec') changeLine(line, Math.max(0, cur - 1));
      else if (b.dataset.act === 'rm') changeLine(line, 0);
    });
  }

  /* ---- add to cart (quick-add & fiche produit) ---- */
  window.paseoAddToCart = function (variantId, qty) {
    return fetch(routes.cart_add_url + '.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: [{ id: variantId, quantity: qty || 1 }] })
    }).then(function (r) { return r.json(); }).then(function (res) {
      return fetchCart().then(function () { openCart(); return res; });
    });
  };
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-add-variant]');
    if (!b) return;
    e.preventDefault();
    var id = b.getAttribute('data-add-variant');
    if (!id) return;
    b.classList.add('loading');
    window.paseoAddToCart(id, 1).then(function () { b.classList.remove('loading'); });
  });

  /* ---- shop the look : popup ---- */
  document.addEventListener('click', function (e) {
    var opener = e.target.closest('.look-open');
    if (opener) {
      var m = document.getElementById(opener.getAttribute('data-look'));
      if (m) { m.hidden = false; document.body.style.overflow = 'hidden'; }
      return;
    }
    if (e.target.closest('[data-close]') || e.target.classList.contains('look-modal')) {
      var mod = e.target.closest('.look-modal');
      if (mod) { mod.hidden = true; document.body.style.overflow = ''; }
    }
  });
  addEventListener('keydown', function (e) {
    if (e.key === 'Escape') {
      document.querySelectorAll('.look-modal:not([hidden])').forEach(function (m) { m.hidden = true; });
      document.body.style.overflow = '';
    }
  });

  if (routes.cart_url) fetchCart();
  window.paseoOpenCart = openCart;
  window.paseoObserveReveals = observeReveals;
})();
